// extracted by mini-css-extract-plugin
module.exports = {"logo-container":"LogoPreview_logo-container__2RoL2","logo":"LogoPreview_logo__aDzqU"};